export { default } from './MagazinesMenu';
